/**
 * Transmission Constants
 *
 * Shared configuration for channel display in transmission components.
 */

import { Mail, MapPin, Printer } from 'lucide-react';
import type React from 'react';

import type { CorrespondenceChannel } from '@/services/api/correspondenceService';

// ============================================================================
// Channel Configuration
// ============================================================================

export interface ChannelConfig {
  /** Display label for the channel */
  label: string;
  /** Lucide icon component */
  icon: React.ElementType;
  /** Past tense verb for confirmation messages (e.g., "Faxed Successfully") */
  verb: string;
}

/**
 * Unified channel configuration for transmission components.
 * Uses Lucide icons for consistent visual representation.
 */
export const CHANNEL_CONFIG: Record<CorrespondenceChannel, ChannelConfig> = {
  fax: { label: 'Fax', icon: Printer, verb: 'Faxed' },
  email: { label: 'Email', icon: Mail, verb: 'Emailed' },
  mailed_letter: { label: 'Mail', icon: MapPin, verb: 'Mailed' },
  mailed_cheque: { label: 'Cheque', icon: MapPin, verb: 'Mailed' },
};
